import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const CreateResponse = loadable(() => import('./CreateResponse'), {});
export const Field = loadable(() => import('./Field'), {});
export const Response = loadable(() => import('./Response'), {});
export const Section = loadable(() => import('./Section'), {});
